import api from "./api";
import endpoints from "./endpoints";

export default {
  get(args) {
    return api.post(endpoints.globalParameters.get, args).then((x) => Promise.resolve(x.data));
  },
  save(args) {
    return api.post(endpoints.globalParameters.update, args).then((x) => Promise.resolve(x.data));
  }
};
